"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootContainer = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _context = require("./context");
var _view = require("../../types/view");
var _UsernameAuthViewContainer = require("../UsernameAuthViewContainer");
var _PhoneAuthViewContainer = require("../PhoneAuthViewContainer");
var _PhoneAuthValidateSmsViewContainer = require("../PhoneAuthValidateSmsViewContainer");
var _PhoneAuthValidateCallViewContainer = require("../PhoneAuthValidateCallViewContainer");
var _RestoreViewContainer = require("../RestoreViewContainer");
var _EmailSentViewContainer = require("../EmailSentViewContainer");
var _TwoFactorAttemptsExhaustedViewContainer = require("../TwoFactorAttemptsExhaustedViewContainer");
var _TwoFactorWithEmailViewContainer = require("../TwoFactorWithEmailViewContainer");
var _TwoFactorWithPhoneViewContainer = require("../TwoFactorWithPhoneViewContainer");
var _TwoFactorWithPhoneValidateSmsViewContainer = require("../TwoFactorWithPhoneValidateSmsViewContainer");
var _TwoFactorWithPhoneValidateCallViewContainer = require("../TwoFactorWithPhoneValidateCallViewContainer");
var _ConfirmPhoneViewContainer = require("../ConfirmPhoneViewContainer");
var _SocialCreateViewContainer = require("../SocialCreateViewContainer");
var _SocialMergeViewContainer = require("../SocialMergeViewContainer");
var _AccountSelectView = require("../AccountSelectView");
var _ConfirmAccountView = require("../ConfirmAccountView");
var _TokenExpiredErrorView = require("../TokenExpiredErrorView");
var _AccountSelectErrorView = require("../AccountSelectErrorView");
var _AgreementViewContainer = require("../AgreementViewContainer");
var _RememberedAccountsViewContainer = require("../RememberedAccountsViewContainer");
var _EnterPhoneNumberViewContainer = require("../EnterPhoneNumberViewContainer");
var _ErrorBoundary = require("../../components/ErrorBoundary");
var _view2 = require("../../selectors/view");
var _autoFocusDisabled = require("../../actions/autoFocusDisabled");
const _excluded = ["useSelector", "useDispatch"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const RootContainer = _ref => {
  let {
      useSelector,
      useDispatch
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const dispatch = useDispatch();
  const activeView = useSelector(_view2.selectActiveView);
  React.useEffect(() => {
    /**
     * Отключенный автофокус должен быть лишь при первой загрузке виджета.
     * При работе с виджетом автофокус на полях виджета авторизации - ожидаемое поведение.
     */
    dispatch((0, _autoFocusDisabled.setAutoFocusDisabled)(false));
  }, []);
  const ViewContainer = React.useMemo(() => {
    switch (activeView) {
      case _view.EActiveView.AuthenticationRegistration:
        return _UsernameAuthViewContainer.UsernameAuthViewContainer;
      case _view.EActiveView.Agreement:
        return _AgreementViewContainer.AgreementViewContainer;
      case _view.EActiveView.RememberedAccountsSelect:
        return _RememberedAccountsViewContainer.RememberedAccountsViewContainer;
      case _view.EActiveView.PhoneAuth:
        return _PhoneAuthViewContainer.PhoneAuthViewContainer;
      case _view.EActiveView.PhoneAuthValidateSms:
        return _PhoneAuthValidateSmsViewContainer.PhoneAuthValidateSmsViewContainer;
      case _view.EActiveView.PhoneAuthValidateCall:
        return _PhoneAuthValidateCallViewContainer.PhoneAuthValidateCallViewContainer;
      case _view.EActiveView.AccountSelect:
        return _AccountSelectView.AccountSelectView;
      case _view.EActiveView.ConfirmSelectedAccount:
        return _ConfirmAccountView.ConfirmAccountViewContainer;
      case _view.EActiveView.TokenExpiredError:
        return _TokenExpiredErrorView.TokenExpiredErrorViewContainer;
      case _view.EActiveView.AccountSelectError:
        return _AccountSelectErrorView.AccountSelectErrorViewContainer;
      case _view.EActiveView.Restore:
        return _RestoreViewContainer.RestoreViewContainer;
      case _view.EActiveView.TwoFactorWithPhone:
        return _TwoFactorWithPhoneViewContainer.TwoFactorWithPhoneViewContainer;
      case _view.EActiveView.TwoFactorPhoneValidateSms:
        return _TwoFactorWithPhoneValidateSmsViewContainer.TwoFactorWithPhoneValidateSmsViewContainer;
      case _view.EActiveView.TwoFactorPhoneValidateCall:
        return _TwoFactorWithPhoneValidateCallViewContainer.TwoFactorWithPhoneValidateCallViewContainer;
      case _view.EActiveView.TwoFactorAttemptsExhausted:
        return _TwoFactorAttemptsExhaustedViewContainer.TwoFactorAttemptsExhaustedViewContainer;
      case _view.EActiveView.TwoFactorWithEmail:
        return _TwoFactorWithEmailViewContainer.TwoFactorWithEmailViewContainer;
      case _view.EActiveView.ConfirmPhone:
        return _ConfirmPhoneViewContainer.ConfirmPhoneViewContainer;
      case _view.EActiveView.EmailSent:
        return _EmailSentViewContainer.EmailSentViewContainer;
      case _view.EActiveView.SocialCreate:
        return _SocialCreateViewContainer.SocialCreateViewContainer;
      case _view.EActiveView.SocialMerge:
        return _SocialMergeViewContainer.SocialMergeViewContainer;
      case _view.EActiveView.EnterPhoneNumber:
        return _EnterPhoneNumberViewContainer.EnterPhoneNumberViewContainer;
      default:
        return null;
    }
  }, [activeView]);
  return /*#__PURE__*/React.createElement(_context.RootContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(_ErrorBoundary.ErrorBoundary, {
    logger: props.logger
  }, ViewContainer && /*#__PURE__*/React.createElement(ViewContainer, null)));
};
exports.RootContainer = RootContainer;